import { render, staticRenderFns } from "./AdminArticlesEditor.vue?vue&type=template&id=073dbaf6&"
import script from "./AdminArticlesEditor.vue?vue&type=script&lang=js&"
export * from "./AdminArticlesEditor.vue?vue&type=script&lang=js&"
import style0 from "./AdminArticlesEditor.vue?vue&type=style&index=0&id=073dbaf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports